import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import { Message } from "../../../framework/src/Message";
import { IBlock } from "../../../framework/src/IBlock";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start
import { makeApiMessage as MakeApiMessage } from "../../../components/src/common";

const configJSON = require("./StoreLocatorConfig");

export interface IStoreTime {
  id: string;
  type: string;
  attributes: {
    id: number;
    day: string;
    opening_time: string;
    closing_time: string;
    is_closed: boolean;
  };
}

export interface IStoreItem {
  id: string;
  type: string;
  attributes: {
    id: number;
    name_en: string;
    name_ar: string;
    address_en: string;
    address_ar: string;
    latitude: string;
    longitude: string;
    phone: string;
    rating: string;
    total_ratings: number;
    google_place_id: string | null;
    google_maps_url: string | null;
    is_active: boolean;
    position: number;
    name: string;
    address: string;
    distance_km: number | null;
    is_open_now: boolean;
    store_times: IStoreTime[];
    image_urls: string[];
  };
}
// Customizable Area End

export interface Props {
  // Customizable Area Start
  navigation: {
    navigate: Function;
    getParam: Function;
  };
  id: string;
  // Customizable Area End
}

export interface S {
  // Customizable Area Start
  storeList: Array<IStoreItem>;
  isLoading: boolean;
  // Customizable Area End
}

export interface SS {}

class StoreListController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  storeListMessageId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.RestAPIResponceSuccessMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
    ];

    this.receive = this.receive.bind(this);
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );

    const successResponse = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (successResponse && requestId === this.storeListMessageId) {
      this.setState({
        isLoading: false,
        storeList: successResponse.data || [],
      });
    }
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount() {
    this.getStoreListApi();
  }

  getStoreListApi = () => {
    this.setState({ isLoading: true });

    const requestMessage = MakeApiMessage({
      url: configJSON.ApiUrls.storesList,
      method: "GET",
    });

    this.storeListMessageId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  // Customizable Area End
}

export default StoreListController;
